import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FooterComponent } from '../../components';

export const SPINNER_NAME = 'CORE_SPINNER_NAME';

@Component({
  template: `
    <div class="www-co" id="core">
      <div class="www-co__content">
        <router-outlet />
      </div>
    </div>
    <app-footer />
    <ngx-spinner
      [bdColor]="'rgba(51,51,51,0.9)'"
      [color]="'#FFF07F'"
      [fullScreen]="true"
      [name]="spinnerName"
      [size]="'large'"
      [type]="'ball-elastic-dots'"
    >
      <p class="c-white">Ładowanie...</p>
    </ngx-spinner>
  `,
  styleUrls: ['./core.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, NgxSpinnerModule, FooterComponent],
})
export class CoreComponent {
  public readonly spinnerName = SPINNER_NAME;
}
